export enum MergeWith {
	MergeWithAllRecords = 0,
	MergePerRecord = 1,
}
